// Competition guidelines now live centrally in the WSAP Download Center.
// Every virtual competition links there instead of a per-event PDF.
const VC_DOWNLOAD_CENTER_URL =
  "https://bpa.org/member-gateway/wsap-download-center/";

window.addEventListener("load", () => {
  const dynamicCards = document.getElementById("vc-dynamic-cards");
  if (!dynamicCards) return;

  const searchInputContainer = document.getElementById(
    "vc-search-input-container",
  );
  const customSelect = document.getElementById("vc-custom-select");
  const display = document.getElementById("vc-selected-display");
  const optionsList = document.getElementById("vc-custom-options");
  const arrow = display?.querySelector("svg");

  const searchInput = document.getElementById("vc-search-input");
  const loader = document.getElementById("vc-loader");
  const loadMoreBtn = document.getElementById("vc-load-more-btn");
  const loadMoreContainer = document.getElementById("vc-load-more-container");

  let searchQuery = "";
  let selectedType = "";
  let currentPage = 1;
  const perPage = 15;

  searchInputContainer?.addEventListener("click", () => {
    document.getElementById("vc-search-input")?.focus();
  });

  display?.addEventListener("click", () => {
    optionsList?.classList.toggle("hidden");
    arrow?.classList.toggle("rotate-180");
  });

  optionsList.querySelectorAll("li").forEach((li) => {
    li.addEventListener("click", () => {
      const val = li.getAttribute("data-value");
      const text = li.textContent.trim();

      display.querySelector(".selected-text").textContent = text;

      selectedType = val;
      fetchData();

      optionsList.classList.add("hidden");
      arrow.classList.remove("rotate-180");
    });
  });

  document.addEventListener("click", (e) => {
    if (!customSelect.contains(e.target)) {
      optionsList.classList.add("hidden");
      arrow.classList.remove("rotate-180");
    }
  });

  function showLoader() {
    loader.classList.remove("hidden");
  }
  function hideLoader() {
    loader.classList.add("hidden");
  }

  function generateHtml(n) {
    // Submission deadlines are intentionally not rendered on virtual competition
    // cards anymore.

    const typeTag =
      Array.isArray(n?.competition_type_names) &&
      n.competition_type_names.length > 0
        ? n.competition_type_names[0]
        : "";

    return `
      <div class="bg-brand-white-smoke flex max-md:flex-col">
        ${
          n?.featured_image_url
            ? `
        <div class="h-auto md:max-w-[11.5rem] w-full border-r-8 border-r-brand-light-sky-blue bg-brand-light-blue"> 
          <img src="${n?.featured_image_url}" alt="card image" class="object-cover max-md:!max-w-[11.5rem] h-auto md:h-full w-full mx-auto"/>
        </div>
        `
            : ""
        }
        <div class="px-9 py-6 w-full">
          <div class="flex justify-between items-center max-md:flex-col gap-5">
            <div class="flex flex-col gap-3">
              <div class="text-brand-dark-blue font-neutraface text-[1.5625rem] leading-[2.0625rem] max-md:text-center">
                <span class="font-semibold">${n?.title}</span>
                ${
                  n?.title && typeTag
                    ? `
                <span class="font-josefin text-brand-light-sky-blue text-[1.6875rem] leading-[2.1875rem]">|</span>
                  `
                    : ""
                }
                ${typeTag}
              </div>
            </div>

            <a href="${VC_DOWNLOAD_CENTER_URL}" target="_blank" rel="noopener noreferrer"
              class="py-3 px-5 bg-brand-warm-beige rounded-[.3125rem] group flex gap-2 hover:gap-3 justify-center items-center flex-shrink-0 !no-underline">
              <span class="text-white text-[1.25rem] leading-[1.5625rem]">
                View Guidelines
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 17" fill="none"
                class="group-hoverml-1 transition-all duration-300">
                <path d="M0.5 0.5L8.80189 8.5L0.5 16.5" stroke="white" stroke-linecap="round" />
              </svg>
            </a>
          </div>

          ${
            n?.text
              ? `
          <div class="w-full h-[.0625rem] bg-brand-warm-beige my-3"></div>
          <div class="text-brand-black font-neutraface !text-[1.5625rem] !leading-[2.0625rem] max-md:*:text-center">
          ${n?.text}
          </div>`
              : ""
          }

        </div>
      </div>
`;
  }

  // Store server-rendered fallback content
  const serverRenderedHtml = dynamicCards.innerHTML;

  async function fetchData(append = false) {
    // Check if Typesense is configured
    if (
      typeof envConfig === "undefined" ||
      !envConfig.TYPESENSE_BASE_URL ||
      !envConfig.TYPESENSE_BASE_URL.startsWith("http")
    ) {
      // Keep server-rendered content as fallback
      return;
    }

    if (!append) {
      currentPage = 1;
      dynamicCards.innerHTML = "";
    }

    showLoader();
    loadMoreContainer.classList.add("hidden");

    const params = {
      q: searchQuery.length > 0 ? searchQuery : "*",
      query_by: "title,text,competition_type",
      sort_by: "competition_number:asc",
      per_page: perPage,
      page: currentPage,
    };

    if (selectedType) params.filter_by = `competition_type:=[${selectedType}]`;

    try {
      const url =
        `${envConfig.TYPESENSE_BASE_URL}:${envConfig.TYPESENSE_PORT}/collections/virtual_competition/documents/search?` +
        new URLSearchParams(params);
      const response = await fetch(url, {
        headers: { "X-TYPESENSE-API-KEY": envConfig.TYPESENSE_SEARCH_ONLY_KEY },
      });
      const data = await response.json();

      if (data?.hits?.length > 0) {
        const newHtml = data?.hits
          ?.map((hit) => generateHtml(hit?.document))
          ?.join("");
        dynamicCards.insertAdjacentHTML("beforeend", newHtml);

        if (data.found > currentPage * perPage) {
          loadMoreContainer.classList.remove("hidden");
        }
      } else if (!append) {
        dynamicCards.innerHTML = `<div class="text-center pt-10 text-brand-black text-[1.25rem] leading-[1.5625rem]">No results found.</div>`;
      }
    } catch (error) {
      console.error("Typesense Error:", error);
      // Restore server-rendered content on failure
      if (!append && dynamicCards.innerHTML === "") {
        dynamicCards.innerHTML = serverRenderedHtml;
      }
    } finally {
      hideLoader();
    }
  }

  loadMoreBtn?.addEventListener("click", () => {
    currentPage++;
    fetchData(true);
  });

  const debounce = (fn, delay) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  };

  searchInput?.addEventListener(
    "input",
    debounce((e) => {
      searchQuery = e.target.value.trim();
      fetchData();
    }, 300),
  );

  if (!searchQuery) {
    fetchData();
  }
});
